export default __webpack_public_path__ + "static/taskdefinition17-29c09271a1bc1e9010b7aa73ecb2af1b.png";